<template>
    <div class="app" :key="monActualite.slug" v-if="monActualite !== undefined">
        <div class="fond-haut-page">
            <div class="img-fond-haut-page" :style="'background-image: url('+monActualite.image+');'" alt="">

            </div>
            <div class="filtre-haut-page"></div>
        </div>

        <section class="page page-histoire page-section-full">
            <section class="section-page section-page-produit">
                <section class="colonne-gauche">
                    <div class="cadre-image-top-y">
                        <div :style="'background-color: var(--blanc-clair-cinquante); background-image: url('+monImageGrand+')'" @click="openModal = true" alt="" class="cursor grande-image-liste-images-carroussel">
                        </div>
                        <template v-if="monActualite.galerie !== null">
                            <div class="div-liste-images-carroussel" v-if="monActualite.galerie.length > 1">
                                <div :style="'background-color: var(--blanc-clair-cinquante); background-size: cover; background-image: url('+image.full_image_url+')'" v-for="image in monActualite.galerie" class="petite-image-liste-images-carroussel cursor" alt=""></div>
                            </div>
                        </template>
                    </div>
                </section>

                <section class="colonne-centrale colonne-centre-avec-gauche">
                    <div class="cadre-description-top-y">
                        <div>
                            <h1 class="c-gris-blanc">{{monActualite.titre}}</h1>
                        </div>

                        <template v-if="monActualite.video !== ''">
                            <iframe class="iframe-video-actu" :src="monActualite.video" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </template>

                        <div>
                            <h3 class="c-gris-blanc">Description</h3>
                            <p class="c-gris-blanc" v-html="monActualite.description"></p>
                        </div>
                    </div>

                    
                </section>

                <section class="colonne-droite pr-section pt-section-150 pb-section-90">
                    <section class="fiche-informations-complementaires-produit">
                        <div>
                            <h5 class="c-gris-blanc">Informations</h5>
                            <div class="liste-informations-complementaires-produit" v-if="monActualite.type !== 'On parle de nous'">
                                <div class="information-complementaire-produit">
                                    <div class="div-petit-svg">
                                        <i class="fa-regular fa-calendar c-gris-blanc"></i>
                                    </div>
                                    <template v-if="monActualite.date_et_horaire.date_debut.date === monActualite.date_et_horaire.date_de_fin.date">
                                        <h6 class="c-gris-blanc">{{fctDates.date(monActualite.date_et_horaire.date_debut.date).date_fr}}</h6>
                                    </template>
                                    <template v-else>
                                        <h6 class="c-gris-blanc">du {{fctDates.date(monActualite.date_et_horaire.date_debut.date).date_fr}} - {{monActualite.date_et_horaire.date_debut.heure.slice(0, 5)}}</h6>><h6 class="c-gris-blanc">du {{fctDates.date(monActualite.date_et_horaire.date_de_fin.date).date_fr}} - {{monActualite.date_et_horaire.date_de_fin.heure.slice(0, 5)}}</h6>
                                    </template>
                                </div>
                                <div class="information-complementaire-produit">
                                    <div class="div-petit-svg">
                                        <i class="fa-regular fa-clock c-gris-blanc"></i>
                                    </div>
                                    <h6 class="c-gris-blanc">de {{monActualite.date_et_horaire.date_debut.heure.slice(0, 5)}} à {{monActualite.date_et_horaire.date_de_fin.heure.slice(0, 5)}}</h6>
                                </div>
                            </div>
                            <template v-if="monActualite.source.nom !== ''">
                                <h6 class="text-light">Source</h6>
                                <div class="liste-informations-complementaires-produit">
                                    <a :href="monActualite.source.lien" target="_blank" class="cadre-recompense-titre" v-if="monActualite.source.lien !== ''">
                                        <img v-if="monActualite.source.logo !== false" :src="monActualite.source.logo" width="auto" height="50px" alt="">
                                        <p class="c-gris-blanc">{{monActualite.source.nom}}</p>
                                    </a>
                                    <div class="cadre-recompense-titre" v-else>
                                        <img v-if="monActualite.source.logo !== false" :src="monActualite.source.logo" width="auto" height="50px" alt="">
                                        <p class="c-gris-blanc">{{monActualite.source.nom}}</p>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div v-if="monActualite.type !== 'On parle de nous'">
                            <h5 class="c-gris-blanc">Cave</h5>
                            <div class="liste-informations-complementaires-produit">
                                <div class="information-complementaire-produit" v-if="monActualite.ouverture.cave">
                                    <div class="div-petit-svg">
                                        <i class="fa-solid fa-check c-blanc-clair"></i>
                                    </div>
                                    <h6 class="c-blanc-clair">Ouverte</h6>
                                </div>
                                <div class="information-complementaire-produit" v-else>
                                    <div class="div-petit-svg">
                                        <i class="fa-solid fa-xmark c-rouge"></i>
                                    </div>
                                    <h6 class="c-rouge">Fermé</h6>
                                </div>
                            </div>
                        </div>
                        <div v-if="monActualite.type !== 'On parle de nous'">
                            <h5 class="c-gris-blanc">Éco-musée</h5>
                            <div class="liste-informations-complementaires-produit">
                                <template v-if="monActualite.ouverture.eco_musee">
                                    <div class="information-complementaire-produit">
                                        <div class="div-petit-svg">
                                            <i class="fa-solid fa-check c-blanc-clair"></i>
                                        </div>
                                        <h6 class="c-blanc-clair">Ouvert</h6>
                                    </div>
                                    <template v-if="monActualite.ouverture.reservation">
                                        <div class="information-complementaire-produit" >
                                            <div class="div-petit-svg">
                                                <i class="fa-solid fa-check c-vign-claire"></i>
                                            </div>
                                            <h6 class="c-vigne-clair">Réservation obligatoire</h6>
                                        </div>
                                        <div class="ligne-bouton-form">
                                            <a href="https://eco-musee.domainethibaut.fr/#/reservation" class="btn-primaire bg-gris-blanc c-gris-fonce"><h5>Réservez votre visite</h5></a>
                                        </div>
                                    </template>
                                </template>
                                <div class="information-complementaire-produit" v-else>
                                    <div class="div-petit-svg">
                                        <i class="fa-solid fa-xmark c-rouge-tres-clair"></i>
                                    </div>
                                    <h6 class="c-rouge-tres-clair">Fermé</h6>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </section>
    </div>
</template>

<script>
    import params           from '@/param/param.js'
    import fctFiltres       from '@/functions/filter.js'
    import fctTris          from '@/functions/tris.js'
    import fctFunctions     from '@/functions/functions.js'
    import fctFunctionsSpe  from '@/functions/functions_specifiques.js'
    import fctDates         from '@/functions/date.js'
    
    export default {
        name: 'Contact',
            data () {
                return { 
                    params,
                    fctFiltres,
                    fctTris,
                    fctFunctions,
                    fctFunctionsSpe,
                    fctDates,



                    monDomaine: [],
                    listeActualites: [],
                    actualiteID: '',
                }
            },

            created(){
                this.actualiteID = this.$route.params.slug;
                axios.get(params.host+'domaine/v1/listeDomaines')
                .then(response => {
                    this.monDomaine = fctFiltres.filterBy(response.data, params.domaineID, 'id')[0]
                    
                    axios.get(params.host+'actualite/v1/listeActualites')
                    .then(response => {
                        this.listeActualites = fctTris.orderByDateDebut(fctFiltres.filterDateType(fctFiltres.filterByDeux(fctFiltres.filterByListe(response.data, this.monDomaine.id, 'domaine'), true, 'affichage', 'affichage'), 'affichage', fctDates.date('').date_en), 'AZ', 'date_et_horaire')
                    }).catch(error => {
                        console.log(error)
                    })
                }).catch(error => {
                    console.log(error)
                })
            },

            computed: {
                monActualite(){
                    return fctFiltres.filterBy(this.listeActualites, this.actualiteID, 'slug')[0]
                },

                monImageGrand(){
                    return this.monActualite.image
                }
            },

            methods: {
                
            }
        }
</script>

<style scoped>
    .cls-1 {
        letter-spacing: 0em;
    }

    .cls-2 {
        font-family: Cinzel-Bold, Cinzel;
        font-size: 129.81px;
        font-weight: 800;
    }

    .cls-3 {
        letter-spacing: -.03em;
    }

    .cls-4 {
        letter-spacing: 0em;
    }
</style>


// WEBPACK FOOTER //
// src/components/Actualite.vue